import React, { Component } from 'react';
import PropTypes from 'prop-types'
import { connect } from 'react-redux'

import {
  resetCertificationVideoPage,
  certificationVideoPageUpdateRequestState,
  certificationVideoPageTriggerRequest,
} from '../actions/certificationVideoPage';

import {
  toggleBodyScroll,
  i18n,
  hideLoadingScreen,
  initializeGA,
  pageViewGA,
  recordSignupFunnelEventGA,
  getAdvertisementIdFromQueryString,
  setAdvertisementReferralUserProperty,
} from '../utils'

import CertificationVideoPage from '../components/CertificationVideoPage';

import {
  REQUEST_UNSTARTED,
} from '../constants/requestStates'

import {
  COMMON_INNER_HEIGHT,
  COMMON_SAFE_AREA_INSETS,
  COMMON_IS_NATIVE,
  COMMON_IS_IOS_DEVICE,
  COMMON_IS_ANDROID_DEVICE,
} from '../constants/commonState'

import {
  FORM_FIELD_HIDE_INTRO_VIDEO,
} from '../constants/formFields'

import {
  GA_LABEL_LOADED_CERTIFICATION_VIDEO_PAGE,
} from '../constants/gaEventLabels'

class CertificationVideoPageContainer extends Component {
  async componentWillMount() {
    await initializeGA(true/*disableCookies*/);
    pageViewGA();
    await recordSignupFunnelEventGA(GA_LABEL_LOADED_CERTIFICATION_VIDEO_PAGE)
    const advertisementId = getAdvertisementIdFromQueryString()
    if (!!advertisementId) {
      await setAdvertisementReferralUserProperty(advertisementId)
    }
  }

  componentDidMount() {
    hideLoadingScreen()
  }
  componentWillUnmount() {
    this.props.dispatch(resetCertificationVideoPage());
  }

  render() {
    return (
      <CertificationVideoPage
        // State
        innerHeight={this.props.innerHeight}
        safeAreaInsets={this.props.safeAreaInsets}
        isNative={this.props.isNative}
        isIOSDevice={this.props.isIOSDevice}
        isAndroidDevice={this.props.isAndroidDevice}
        iOSAppIsAvailable={this.props.iOSAppIsAvailable}
        androidAppIsAvailable={this.props.androidAppIsAvailable}
        i18n={i18n}
        requestResults={this.props.requestResults}
        onUpdateRequestState={(requestType, body) => this.props.dispatch(certificationVideoPageUpdateRequestState(requestType, REQUEST_UNSTARTED, body))}
        onResetRequestState={requestType => this.props.dispatch(certificationVideoPageUpdateRequestState(requestType, REQUEST_UNSTARTED))}
        onTriggerRequest={requestType => this.props.dispatch(certificationVideoPageTriggerRequest(requestType))}
        // Actions
      />
    );
  }
}

CertificationVideoPageContainer.propTypes = {
  requestResults: PropTypes.object.isRequired,
  dispatch: PropTypes.func.isRequired,
  innerHeight: PropTypes.number.isRequired,
  isNative: PropTypes.bool.isRequired,
  isIOSDevice: PropTypes.bool.isRequired,
  isAndroidDevice: PropTypes.bool.isRequired,
  safeAreaInsets: PropTypes.object.isRequired,
}

const mapStateToProps = state => ({
  ...state.certificationVideoPage,
  innerHeight: state.common[COMMON_INNER_HEIGHT],
  isNative: state.common[COMMON_IS_NATIVE],
  isIOSDevice: state.common[COMMON_IS_IOS_DEVICE],
  isAndroidDevice: state.common[COMMON_IS_ANDROID_DEVICE],
  safeAreaInsets: state.common[COMMON_SAFE_AREA_INSETS],
});

export default connect(mapStateToProps)(CertificationVideoPageContainer);
